export default "__VITE_ASSET__YsiuZH5E__"